import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import {
  TuiTableModule,
  TuiTablePaginationModule
} from "@taiga-ui/addon-table";
import { TuiLetModule } from "@taiga-ui/cdk";
import { TuiButtonModule, TuiFormatNumberPipeModule } from "@taiga-ui/core";
import { KwikUITablePaginationComponent } from "./table-pagination.component";

@NgModule({
  declarations: [KwikUITablePaginationComponent],
  imports: [
    CommonModule,
    TuiTableModule,
    TuiFormatNumberPipeModule,
    TuiLetModule,
    TuiButtonModule,
    TuiTablePaginationModule
  ],
  exports: [KwikUITablePaginationComponent]
})
export class KwikUITablePaginationModule {}
